import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import InsightsDashboard from './InsightsDashboard';
import { withInstallation } from '../../components/InstallationContext';
import { getEnabledInsightTabs, isInsightsModuleEnabled } from '../../lib/insightsFeature';
import authManager from '../../lib/authManager';
import { INSIGHT_TAB_PERMISSIONS } from '../../lib/insightsPermissions';

// Tab ids supported by the DRIVO dashboard. The sidebar "Insights" section
// links to each of these, and the in-page tab bar stays in sync via the URL.
const INSIGHT_TABS = ['overview', 'leakage', 'channels', 'staff', 'network', 'arrivals', 'ops'];

function InsightsPage({ match, facility, installation }) {
    const configuredTabs = getEnabledInsightTabs(facility);
    const enabledTabs = configuredTabs.filter((tab) =>
        authManager.hasPermission(INSIGHT_TAB_PERMISSIONS[tab], installation.id)
    );

    if (!isInsightsModuleEnabled(facility) || enabledTabs.length === 0) return null;

    return (
        <Switch>
            <Route
                path={`${match.path}/:tab`}
                render={({ match: m, history }) => {
                    const requestedTab = INSIGHT_TABS.includes(m.params.tab) ? m.params.tab : enabledTabs[0];

                    if (
                        INSIGHT_TABS.includes(m.params.tab) &&
                        !authManager.hasPermission(INSIGHT_TAB_PERMISSIONS[m.params.tab], installation.id)
                    ) {
                        return <Redirect to={`/${installation.brandingKey}/profile`} />;
                    }

                    const tab = enabledTabs.includes(requestedTab) ? requestedTab : enabledTabs[0];

                    if (tab !== m.params.tab) {
                        return <Redirect to={`${match.url}/${tab}`} />;
                    }

                    return (
                        <InsightsDashboard
                            tab={tab}
                            setTab={(t) => history.push(`${match.url}/${t}`)}
                            enabledTabs={enabledTabs}
                            installation={installation}
                            facility={facility}
                        />
                    );
                }}
            />
            <Redirect to={`${match.url}/${enabledTabs[0]}`} />
        </Switch>
    );
}

export default withInstallation(InsightsPage);
